export enum DiagnosisStatus {
  Open = 1,
  Stable = 2,
  Resolved = 3,
}
